import { useMediaQuery } from './useMediaQuery'
import { mediaQueries } from '../utils/breakpoints'

export function useReducedMotion(): boolean {
  return useMediaQuery(mediaQueries.reducedMotion)
}
